/**
 * File animations.js
 * GSAP https://gsap.com/docs/v3/
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.animated-counter').forEach((number) => {
    const end = number.getAttribute('data-end');
    const duration = number.getAttribute('data-duration');

    if (end && number) {
        number.innerHTML = '0';

        gsap.to(number, {
            scrollTrigger: {
                trigger: number,
            },
            innerText: end,
            duration: duration,
            ease: 'power1.inOut',
            snap: { innerText: 1 },
            onUpdate: function() {
                number.innerText = Math.ceil(number.innerText);
            }
        });
    }
});